import { Column } from "src/app/shared/components/table/model/column";

export interface AlertSettingsModel {
  title: string;
  isMatIcon?: boolean;
  iconName?: string;
  columns: Array<Column>;
  rows;
  totElements: number;
  totPages: number;
}

export const alertListColumns = {
  alertListColumns:
    [
      {
        "label": "date_alert",
        "order": 1,
        "id": "created_at",
        "orderable": false,
        "type": "text",
        "width": 10
      },
      {
        "label": "title_alert",
        "order": 2,
        "id": "title",
        "orderable": false,
        "type": "text_bold",
        "width": 20
      },
      {
        "label": "description_alert",
        "order": 3,
        "id": "description",
        "orderable": false,
        "type": "text",
        "width": 40
      },
      {
        "label": "",
        "order": 4,
        "id": "iconChange",
        "orderable": false,
        "type": "icon",
        "width": 5
      }
    ]
};